import React from 'react';
import OnboardingContent from './onboardingContent';

const getSteps = (isLiveVetEnabled) => {
  const MAX_STEP = isLiveVetEnabled ? 5 : 4;
  return [
    {
      target: '.pageImageBanner',
      content: (
        <OnboardingContent
          title="Take a tour of your new portal"
          content="Welcome to your dashboard, where you can see updates on your claims and documents."
          currentStep={1}
          maxStep={MAX_STEP}
        />
      ),
      disableBeacon: true,
      hideFooter: true,
      disableOverlayClose: true
    },
    ...(isLiveVetEnabled
      ? [
          {
            target: '.liveVetMenuItem',
            content: (
              <OnboardingContent
                title="Live vet"
                content="This is where you can connect to a trusted vet to help your pet within minutes, 24/7 via chat or online video call."
                currentStep={2}
                maxStep={MAX_STEP}
              />
            ),
            disableBeacon: true,
            disableOverlayClose: true
          }
        ]
      : []),
    {
      target: '.dashboardMyPets',
      content: (
        <OnboardingContent
          title="My pets"
          content="This is where you will find key information about your pet/s. You can view details of their cover and personalise your portal by adding your favourite photos."
          currentStep={isLiveVetEnabled ? 3 : 2}
          maxStep={MAX_STEP}
        />
      ),
      disableBeacon: true,
      disableOverlayClose: true,
      placement: 'top-left'
    },
    {
      target: '.myLatestClaims',
      content: (
        <OnboardingContent
          title="My latest claims"
          content="This is where you will see a summary of your most recent claims including progress updates. You can also make a new claim or click through to see all your claims."
          currentStep={isLiveVetEnabled ? 4 : 3}
          maxStep={MAX_STEP}
        />
      ),
      disableBeacon: true,
      disableOverlayClose: true,
      placement: 'top-left'
    },
    {
      target: '.helpCenterMenuItem',
      content: (
        <OnboardingContent
          title="Help centre"
          content="If you get stuck, access your new Help Centre. It contains useful FAQs on topics such as claims and policy coverage to help you understand your policy."
          currentStep={MAX_STEP}
          maxStep={MAX_STEP}
        />
      ),
      disableBeacon: true,
      disableOverlayClose: true
    }
  ];
};

export default getSteps;
